import React from 'react';
import { Select } from 'antd';
import styles from './styles';
import textStyles from '../rbh-text/styles';
import { FormattedMessage } from 'react-intl';

export const RBHSelect = (p: any) => {
  return (
    <Select size='large' {...p}
      style={{...styles.selectDefault, ...textStyles.formText, ...p.style}}
      placeholder={ p.placeholder ? <FormattedMessage id={p.placeholder} /> : ''}
    >
      {p.children}
    </Select>
  );
};

export default RBHSelect;
